/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { UiVariablesPb } from "../../../../gen/skills/ui_variables";

export const protobufPackage = "skills";

export interface SpoofPhoneUiVariablesActionArgs {
  durationS: number;
  phoneUiVariables: UiVariablesPb | undefined;
}

export interface SpoofPhoneUiVariablesResultData {
}

export interface SpoofPhoneUiVariablesActionStateData {
}

function createBaseSpoofPhoneUiVariablesActionArgs(): SpoofPhoneUiVariablesActionArgs {
  return { durationS: 0, phoneUiVariables: undefined };
}

export const SpoofPhoneUiVariablesActionArgs = {
  encode(message: SpoofPhoneUiVariablesActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.durationS !== 0) {
      writer.uint32(9).double(message.durationS);
    }
    if (message.phoneUiVariables !== undefined) {
      UiVariablesPb.encode(message.phoneUiVariables, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofPhoneUiVariablesActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofPhoneUiVariablesActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 9) {
            break;
          }

          message.durationS = reader.double();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.phoneUiVariables = UiVariablesPb.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpoofPhoneUiVariablesActionArgs {
    return {
      durationS: isSet(object.durationS) ? globalThis.Number(object.durationS) : 0,
      phoneUiVariables: isSet(object.phoneUiVariables) ? UiVariablesPb.fromJSON(object.phoneUiVariables) : undefined,
    };
  },

  toJSON(message: SpoofPhoneUiVariablesActionArgs): unknown {
    const obj: any = {};
    if (message.durationS !== 0) {
      obj.durationS = message.durationS;
    }
    if (message.phoneUiVariables !== undefined) {
      obj.phoneUiVariables = UiVariablesPb.toJSON(message.phoneUiVariables);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofPhoneUiVariablesActionArgs>, I>>(base?: I): SpoofPhoneUiVariablesActionArgs {
    return SpoofPhoneUiVariablesActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofPhoneUiVariablesActionArgs>, I>>(
    object: I,
  ): SpoofPhoneUiVariablesActionArgs {
    const message = createBaseSpoofPhoneUiVariablesActionArgs();
    message.durationS = object.durationS ?? 0;
    message.phoneUiVariables = (object.phoneUiVariables !== undefined && object.phoneUiVariables !== null)
      ? UiVariablesPb.fromPartial(object.phoneUiVariables)
      : undefined;
    return message;
  },
};

function createBaseSpoofPhoneUiVariablesResultData(): SpoofPhoneUiVariablesResultData {
  return {};
}

export const SpoofPhoneUiVariablesResultData = {
  encode(_: SpoofPhoneUiVariablesResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofPhoneUiVariablesResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofPhoneUiVariablesResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpoofPhoneUiVariablesResultData {
    return {};
  },

  toJSON(_: SpoofPhoneUiVariablesResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofPhoneUiVariablesResultData>, I>>(base?: I): SpoofPhoneUiVariablesResultData {
    return SpoofPhoneUiVariablesResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofPhoneUiVariablesResultData>, I>>(_: I): SpoofPhoneUiVariablesResultData {
    const message = createBaseSpoofPhoneUiVariablesResultData();
    return message;
  },
};

function createBaseSpoofPhoneUiVariablesActionStateData(): SpoofPhoneUiVariablesActionStateData {
  return {};
}

export const SpoofPhoneUiVariablesActionStateData = {
  encode(_: SpoofPhoneUiVariablesActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpoofPhoneUiVariablesActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpoofPhoneUiVariablesActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SpoofPhoneUiVariablesActionStateData {
    return {};
  },

  toJSON(_: SpoofPhoneUiVariablesActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SpoofPhoneUiVariablesActionStateData>, I>>(
    base?: I,
  ): SpoofPhoneUiVariablesActionStateData {
    return SpoofPhoneUiVariablesActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpoofPhoneUiVariablesActionStateData>, I>>(
    _: I,
  ): SpoofPhoneUiVariablesActionStateData {
    const message = createBaseSpoofPhoneUiVariablesActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
